import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/content';
import { CTAButton } from './CTAButton';
export function PainSection() {
  return <section className="bg-cream px-4 py-9 sm:px-6 sm:py-12" data-id="element-180" data-mp="38vkhsl9y3zyf">
      <div className="mx-auto max-w-5xl" data-id="element-181" data-mp="2uxds3sf5h69u">
        <p className="font-display text-[11px] font-bold uppercase tracking-[0.18em] text-sage-dark sm:text-xs" data-id="element-182" data-mp="2v0i5ngei9ed6">
          La réalité du métier
        </p>
        <h2 className="mt-1.5 max-w-3xl text-xl font-extrabold leading-tight sm:text-3xl" data-id="element-183" data-mp="2l7ki2vunoz7p">
          Si vous êtes orthophoniste, vous connaissez probablement ces situations.
        </h2>
        <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-184" data-mp="2bb7m1rbn299s">
          {pains.map(pain => <li key={pain} className="flex gap-2.5 rounded-lg border border-sage/40 bg-white p-3.5 text-[13px] leading-snug text-graphite sm:text-sm" data-id="element-185" data-mp="2g8hoc7k4mff1">
              <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-186" data-mp="278uj1aoa0pgp" />
              <span data-id="element-187" data-mp="3rmhn0z7xxq7x">{pain}</span>
            </li>)}
        </ul>
        <p className="mt-5 font-display text-base font-extrabold uppercase leading-tight text-petrol sm:text-2xl" data-id="element-188" data-mp="3rovhp6ypl0ey">
          Combien de séances voulez-vous encore reconstruire à partir de zéro ?
        </p>
        <CTAButton className="mt-4 max-w-md" data-id="element-189" data-mp="gpyg49taln8">
          Accédez à Orthophonie Pro™ maintenant
        </CTAButton>
      </div>
    </section>;
}